import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetGoogleReviews } from '../../hooks/useGetGoogleReviews';
import ReviewCard from './ReviewCard';
import appConfig from '../../config/appConfig';

const GoogleReviews: React.FC = () => {
    const { reviews, isLoading, error } = useGetGoogleReviews();
    const { t } = useTranslation();

    const GOOGLE_REVIEWS_URL = `https://search.google.com/local/reviews?placeid=${appConfig.features.googleReviews.placeId}`;

    if (isLoading) {
        return <div>{t('common.loading', 'Caricamento recensioni...')}</div>;
    }

    if (error) {
        return <div className="alert alert-warning">{t('reviews.loadError', 'Impossibile caricare le recensioni.')}</div>;
    }

    if (reviews.length === 0) {
        return null; // Non mostrare nulla se non ci sono recensioni
    }

    return (
        <div className="container-fluid w-85">
            <div className="row">
                <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                    <h2>{t('reviews.title')}</h2>
                    <p className='sub-title mb-4'>{t('reviews.title')}</p>
                    <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('reviews.para1') as string }} />
                    <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                        <span>
                            {t('reviews.readAll', 'Leggi tutte le recensioni')}
                        </span>
                    </a>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="row flex-column justify-content-center align-items-center ">
                        {reviews.map((review, index) => (
                            <div key={index} className="col-lg-12 col-xl-10 mb-3">
                                <ReviewCard review={review} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GoogleReviews;